/*
  BLUE QUILL ANGLER - LIVE RIVER FLOW TICKER
  Asset: bqa-riverflow-ticker.js

  Isolated from all other BQA river scripts.

  Current readings:
  - USGS: instantaneous values
  - Colorado DWR: latest station reading
  Trend:
  - USGS: recent instantaneous series
  - DWR: hourly series for trend only

  Refresh: every 15 minutes
  Hover/focus pause: explicit JS + CSS
*/

(function () {
  "use strict";

  var ROOT_ID = "bqa-riverflow-ticker";
  var root = document.getElementById(ROOT_ID);
  if (!root || root.getAttribute("data-initialized") === "true") return;

  root.setAttribute("data-initialized", "true");

  var track = document.getElementById("bqa-ticker-track");
  var REFRESH_MS = 15 * 60 * 1000;
  var STALE_MS = 6 * 60 * 60 * 1000;

  /*
    Report links are kept in one place for easy editing.
    If a specific page handle changes, edit only the url value below.
  */
  var RIVERS = [
    {
      id: "arkansas-salida",
      river: "Arkansas",
      location: "Salida",
      usgs: "07093700",
      dwr: "ARKSALCO",
      preferDwr: true,
      url: "/pages/riverlist-home"
    },
    {
      id: "bear-morrison",
      river: "Bear Creek",
      location: "Morrison",
      usgs: "06710500",
      dwr: "BCRMORCO",
      preferDwr: true,
      url: "/pages/river-page-bear-creek"
    },
    {
      id: "blue-dillon",
      river: "Blue River",
      location: "Below Dillon",
      usgs: "09050700",
      url: "/pages/river-page-blue-river"
    },
    {
      id: "clear-golden",
      river: "Clear Creek",
      location: "Golden",
      usgs: "06719505",
      url: "/pages/river-page-clear-creek"
    },
    {
      id: "colorado-kremmling",
      river: "Colorado",
      location: "Kremmling",
      usgs: "09058000",
      url: "/pages/river-page-upper-colorado"
    },
    {
      id: "eagle-gypsum",
      river: "Eagle River",
      location: "Gypsum",
      usgs: "09070000",
      url: "/pages/riverlist-home"
    },
    {
      id: "fryingpan-ruedi",
      river: "Fryingpan",
      location: "Ruedi",
      usgs: "09080400",
      url: "/pages/riverlist-home"
    },
    {
      id: "roaringfork-glenwood",
      river: "Roaring Fork",
      location: "Glenwood Springs",
      usgs: "09085000",
      url: "/pages/riverlist-home"
    },
    {
      id: "platte-dream",
      river: "South Platte",
      location: "Dream Stream",
      dwr: "PLAHARCO",
      preferDwr: true,
      url: "/pages/riverlist-home"
    },
    {
      id: "platte-elevenmile",
      river: "South Platte",
      location: "11 Mile Canyon",
      dwr: "PLAGEOCO",
      preferDwr: true,
      url: "/pages/riverlist-home"
    },
    {
      id: "platte-cheesman",
      river: "South Platte",
      location: "Cheesman",
      usgs: "06701500",
      dwr: "PLACHECO",
      preferDwr: true,
      url: "/pages/river-page-cheesman-canyon"
    },
    {
      id: "platte-deckers",
      river: "South Platte",
      location: "Deckers",
      usgs: "06701900",
      url: "/pages/river-page-deckers"
    },
    {
      id: "northfork-bailey",
      river: "North Fork South Platte",
      location: "Bailey",
      dwr: "PLABAICO",
      preferDwr: true,
      url: "/pages/riverlist-home"
    },
    {
      id: "williamsfork",
      river: "Williams Fork",
      location: "Below Reservoir",
      usgs: "09038500",
      url: "/pages/riverlist-home"
    }
  ];

  function fetchJson(url) {
    return fetch(url, { cache: "no-store" }).then(function (response) {
      if (!response.ok) throw new Error("HTTP " + response.status);
      return response.json();
    });
  }

  function safeNumber(value) {
    var n = Number(value);
    if (!Number.isFinite(n) || n <= -999000) return null;
    return n;
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function formatFlow(value) {
    if (value == null) return "--";
    if (value < 10) return value.toFixed(1);
    return Math.round(value).toLocaleString();
  }

  function cToF(value) {
    return (Number(value) * 9 / 5) + 32;
  }

  function normalizeTemperature(value, units) {
    var n = safeNumber(value);
    if (n == null) return null;

    var unitText = String(units || "").toUpperCase();

    if (unitText.indexOf("C") !== -1 && unitText.indexOf("F") === -1) {
      return cToF(n);
    }

    if (!unitText && n < 45) return cToF(n);

    return n;
  }

  function tempClass(value) {
    if (value == null) return "";
    if (value >= 68) return "is-danger";
    if (value >= 66) return "is-caution";
    return "";
  }

  function ageText(time) {
    if (!time) return "TIME N/A";

    var stamp = new Date(time).getTime();
    if (!stamp) return "TIME N/A";

    var minutes = Math.max(0, Math.round((Date.now() - stamp) / 60000));

    if (minutes < 2) return "JUST UPDATED";
    if (minutes < 60) return minutes + " MIN";

    var hours = Math.round(minutes / 60);
    if (hours < 24) return hours + " HR";

    return Math.round(hours / 24) + " DAY";
  }

  function isStale(time) {
    if (!time) return false;
    var stamp = new Date(time).getTime();
    return stamp && Date.now() - stamp > STALE_MS;
  }

  function trendFromPoints(points) {
    if (!points || points.length < 2) return "steady";

    var latest = points[points.length - 1].value;
    var earlierIndex = Math.max(0, points.length - 4);
    var earlier = points[earlierIndex].value;

    if (!Number.isFinite(latest) || !Number.isFinite(earlier)) return "steady";

    var base = Math.max(Math.abs(earlier), 1);
    var pct = ((latest - earlier) / base) * 100;

    if (pct >= 3) return "rising";
    if (pct <= -3) return "falling";
    return "steady";
  }

  function trendSymbol(trend) {
    if (trend === "rising") return "↑";
    if (trend === "falling") return "↓";
    return "→";
  }

  function usgsSeriesCode(series) {
    try {
      return String(series.variable.variableCode[0].value || "");
    } catch (e) {
      return "";
    }
  }

  function usgsReadings(series) {
    var output = [];

    if (!series || !Array.isArray(series.values)) return output;

    series.values.forEach(function (set) {
      var readings = set && Array.isArray(set.value) ? set.value : [];

      readings.forEach(function (reading) {
        var value = safeNumber(reading.value);
        var timeMs = new Date(reading.dateTime || 0).getTime();

        if (value == null || !timeMs) return;

        output.push({
          value: value,
          time: reading.dateTime,
          timeMs: timeMs
        });
      });
    });

    output.sort(function (a, b) {
      return a.timeMs - b.timeMs;
    });

    return output;
  }

  function fetchUsgs(river) {
    var params = new URLSearchParams({
      format: "json",
      sites: river.usgs,
      parameterCd: "00060,00010",
      siteStatus: "all",
      period: "P1D"
    });

    return fetchJson(
      "https://waterservices.usgs.gov/nwis/iv/?" + params.toString()
    ).then(function (payload) {
      var series =
        payload && payload.value && Array.isArray(payload.value.timeSeries)
          ? payload.value.timeSeries
          : [];

      var flowPoints = [];
      var tempPoints = [];

      series.forEach(function (item) {
        var code = usgsSeriesCode(item);

        if (code === "00060") {
          flowPoints = flowPoints.concat(usgsReadings(item));
        }

        if (code === "00010") {
          tempPoints = tempPoints.concat(usgsReadings(item));
        }
      });

      flowPoints.sort(function (a, b) { return a.timeMs - b.timeMs; });
      tempPoints.sort(function (a, b) { return a.timeMs - b.timeMs; });

      if (!flowPoints.length) throw new Error("No USGS flow reading");

      var latestFlow = flowPoints[flowPoints.length - 1];
      var latestTemp = tempPoints.length ? tempPoints[tempPoints.length - 1] : null;

      return {
        flow: latestFlow.value,
        time: latestFlow.time,
        tempF: latestTemp ? cToF(latestTemp.value) : null,
        trend: trendFromPoints(flowPoints),
        source: "USGS"
      };
    });
  }

  function dwrRows(payload) {
    if (Array.isArray(payload)) return payload;
    if (!payload || typeof payload !== "object") return [];

    return (
      payload.ResultList ||
      payload.resultList ||
      payload.results ||
      payload.Result ||
      []
    );
  }

  function dwrCode(row) {
    return String(
      row.abbrev ||
      row.Abbrev ||
      row.stationAbbrev ||
      row.stationabbrev ||
      row.stationAbbreviation ||
      row.stationabbreviation ||
      ""
    ).toUpperCase();
  }

  function dwrParameter(row) {
    return String(
      row.parameter ||
      row.Parameter ||
      row.measType ||
      row.meastype ||
      ""
    ).toUpperCase();
  }

  function dwrValue(row) {
    return safeNumber(
      row.measValue != null ? row.measValue :
      row.measvalue != null ? row.measvalue :
      row.value != null ? row.value :
      row.Value != null ? row.Value :
      row.amount
    );
  }

  function dwrDate(row) {
    return (
      row.measDateTime ||
      row.measdatetime ||
      row.measDate ||
      row.measdate ||
      row.dateTime ||
      row.datetime ||
      row.date ||
      row.Date ||
      null
    );
  }

  function dwrUnits(row) {
    return (
      row.measUnit ||
      row.measunit ||
      row.units ||
      row.unit ||
      ""
    );
  }

  function parseDwrLatest(payload, code, parameter) {
    var targetCode = String(code).toUpperCase();
    var targetParameter = String(parameter).toUpperCase();
    var best = null;

    dwrRows(payload).forEach(function (row) {
      var rowCode = dwrCode(row);
      var rowParameter = dwrParameter(row);
      var value = dwrValue(row);
      var time = dwrDate(row);
      var timeMs = new Date(time || 0).getTime();

      if (rowCode && rowCode !== targetCode) return;

      if (rowParameter) {
        if (targetParameter === "DISCHRG" && rowParameter !== "DISCHRG") return;
        if (
          targetParameter === "WATTEMP" &&
          rowParameter !== "WATTEMP" &&
          rowParameter.indexOf("TEMP") === -1
        ) return;
      }

      if (value == null || !timeMs) return;

      if (targetParameter === "WATTEMP") {
        value = normalizeTemperature(value, dwrUnits(row));
      }

      if (value == null) return;

      if (!best || timeMs > best.timeMs) {
        best = {
          value: value,
          time: time,
          timeMs: timeMs
        };
      }
    });

    return best;
  }

  function fetchDwrLatest(code, parameter) {
    var params = new URLSearchParams({
      format: "json",
      abbrev: code,
      parameter: parameter,
      pageSize: "100"
    });

    return fetchJson(
      "https://dwr.state.co.us/Rest/GET/api/v2/telemetrystations/telemetrystation/?" +
      params.toString()
    ).then(function (payload) {
      return parseDwrLatest(payload, code, parameter);
    });
  }

  function yyyyMmDd(date) {
    return date.getFullYear() + "-" +
      String(date.getMonth() + 1).padStart(2, "0") + "-" +
      String(date.getDate()).padStart(2, "0");
  }

  function fetchDwrTrend(code) {
    var end = new Date();
    var start = new Date();
    start.setDate(start.getDate() - 1);

    var params = new URLSearchParams({
      format: "json",
      abbrev: code,
      parameter: "DISCHRG",
      startDate: yyyyMmDd(start),
      endDate: yyyyMmDd(end),
      pageSize: "500"
    });

    return fetchJson(
      "https://dwr.state.co.us/Rest/GET/api/v2/telemetrystations/telemetrytimeserieshour/?" +
      params.toString()
    ).then(function (payload) {
      var points = [];

      dwrRows(payload).forEach(function (row) {
        var value = dwrValue(row);
        var time = dwrDate(row);
        var timeMs = new Date(time || 0).getTime();

        if (value == null || !timeMs) return;

        points.push({
          value: value,
          time: time,
          timeMs: timeMs
        });
      });

      points.sort(function (a, b) { return a.timeMs - b.timeMs; });

      return trendFromPoints(points);
    }).catch(function () {
      return "steady";
    });
  }

  function fetchDwr(river) {
    return Promise.all([
      fetchDwrLatest(river.dwr, "DISCHRG"),
      fetchDwrLatest(river.dwr, "WATTEMP").catch(function () { return null; }),
      fetchDwrTrend(river.dwr)
    ]).then(function (parts) {
      var flow = parts[0];
      var temp = parts[1];
      var trend = parts[2];

      if (!flow) throw new Error("No DWR flow reading");

      return {
        flow: flow.value,
        time: flow.time,
        tempF: temp ? temp.value : null,
        trend: trend || "steady",
        source: "CO DWR"
      };
    });
  }

  function fetchRiver(river) {
    if (river.preferDwr && river.dwr) {
      return fetchDwr(river).catch(function () {
        if (river.usgs) return fetchUsgs(river);
        throw new Error("River unavailable");
      });
    }

    if (river.usgs) return fetchUsgs(river);
    if (river.dwr) return fetchDwr(river);

    return Promise.reject(new Error("No source configured"));
  }

  function itemHtml(result) {
    var river = result.river;
    var data = result.data;

    if (!data) {
      return (
        '<a class="bqa-ticker-item" href="' + escapeHtml(river.url) + '">' +
          '<span class="bqa-ticker-river">' + escapeHtml(river.river) + '</span>' +
          '<span class="bqa-ticker-location">' + escapeHtml(river.location) + '</span>' +
          '<span class="bqa-ticker-sep">•</span>' +
          '<span class="bqa-ticker-age is-stale">DATA UNAVAILABLE</span>' +
        '</a>'
      );
    }

    var stale = isStale(data.time);
    var temp = "";

    if (data.tempF != null) {
      temp =
        '<span class="bqa-ticker-sep">•</span>' +
        '<span class="bqa-ticker-temp ' + tempClass(data.tempF) + '">' +
          Math.round(data.tempF) + '°F' +
        '</span>';
    }

    return (
      '<a class="bqa-ticker-item" href="' + escapeHtml(river.url) + '">' +
        '<span class="bqa-ticker-river">' + escapeHtml(river.river) + '</span>' +
        '<span class="bqa-ticker-location">' + escapeHtml(river.location) + '</span>' +
        '<span class="bqa-ticker-trend ' + escapeHtml(data.trend) + '" title="' +
          escapeHtml(data.trend) + '">' + trendSymbol(data.trend) + '</span>' +
        '<span class="bqa-ticker-flow">' + formatFlow(data.flow) + ' CFS</span>' +
        temp +
        '<span class="bqa-ticker-sep">•</span>' +
        '<span class="bqa-ticker-age' + (stale ? ' is-stale' : '') + '">' +
          escapeHtml(ageText(data.time)) + (stale ? ' · STALE' : '') +
        '</span>' +
      '</a>'
    );
  }

  function setDuration() {
    var firstHalf = track.scrollWidth / 2;
    if (!firstHalf) return;

    /*
      Roughly 62 pixels/second on desktop.
      Longer ticker contents automatically receive a longer duration.
    */
    var seconds = Math.max(90, Math.round(firstHalf / 62));
    root.style.setProperty("--bqa-ticker-duration", seconds + "s");
  }

  function render(results) {
    var onePass = results.map(itemHtml).join("");

    /*
      Duplicate the complete data set so a -50% animation produces
      a seamless continuous loop.
    */
    track.classList.remove("is-ready");
    track.innerHTML =
      '<div class="bqa-ticker-pass">' + onePass + '</div>' +
      '<div class="bqa-ticker-pass" aria-hidden="true">' + onePass + '</div>';

    var passes = track.querySelectorAll(".bqa-ticker-pass");
    passes.forEach(function (pass) {
      pass.style.display = "flex";
      pass.style.alignItems = "stretch";
    });

    requestAnimationFrame(function () {
      setDuration();
      track.classList.add("is-ready");

      var hoveredItem = root.querySelector(".bqa-ticker-item:hover");
      if (hoveredItem) pauseTicker();
    });
  }


  function pauseTicker() {
    root.classList.add("is-paused");
    track.style.setProperty("animation-play-state", "paused", "important");

    if (typeof track.getAnimations === "function") {
      track.getAnimations().forEach(function (animation) {
        try { animation.pause(); } catch (e) {}
      });
    }
  }

  function resumeTicker() {
    root.classList.remove("is-paused");
    track.style.removeProperty("animation-play-state");

    if (typeof track.getAnimations === "function") {
      track.getAnimations().forEach(function (animation) {
        try { animation.play(); } catch (e) {}
      });
    }
  }

  /*
    Pause specifically when the pointer is over a river item.
    Event delegation keeps working after the ticker is re-rendered.
  */
  root.addEventListener("pointerover", function (event) {
    var item = event.target.closest(".bqa-ticker-item");
    if (item && root.contains(item)) {
      pauseTicker();
    }
  });

  root.addEventListener("pointerout", function (event) {
    var fromItem = event.target.closest(".bqa-ticker-item");
    if (!fromItem) return;

    var toItem = event.relatedTarget && event.relatedTarget.closest
      ? event.relatedTarget.closest(".bqa-ticker-item")
      : null;

    if (!toItem) {
      resumeTicker();
    }
  });

  root.addEventListener("focusin", function (event) {
    if (event.target.closest(".bqa-ticker-item")) {
      pauseTicker();
    }
  });

  root.addEventListener("focusout", function (event) {
    var next = event.relatedTarget;
    if (!next || !next.closest || !next.closest(".bqa-ticker-item")) {
      resumeTicker();
    }
  });

  function loadAll() {
    Promise.all(
      RIVERS.map(function (river) {
        return fetchRiver(river)
          .then(function (data) {
            return { river: river, data: data };
          })
          .catch(function () {
            return { river: river, data: null };
          });
      })
    ).then(render);
  }

  loadAll();
  setInterval(loadAll, REFRESH_MS);

  window.addEventListener("resize", function () {
    if (track.classList.contains("is-ready")) setDuration();
  });
})();